export default __webpack_public_path__ + "static/media/main_logo.06c5570e.svg";